import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import HETLecturerSupportSetupSearchForm from './HETLecturerSupportSetupSearchForm';
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from "../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'HETLecturerSupportCode', numeric: false, disablePadding: true, label: 'HET Lecturer Support Programme Code' },
    { id: 'HETLecturerSupportTitle', numeric: false, disablePadding: true, label: 'HET Lecturer Support Programme Title' },
    { id: 'OFOOccupation', numeric: false, disablePadding: true, label: 'OFO Occupation Code' },
    { id: 'Qualification', numeric: false, disablePadding: true, label: 'Qualification' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' }
];


const utils = new ViewUtils();

class HETLecturerSupportSetupSearch extends Component {
    constructor(props) {
        super(props)

        let model = {
            HETLecturerSupportCode: "",
            HETLecturerSupportTitle: ""
        }

        this.searchParameters = !utils.isNull(this.props.programmeId) ?
            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "HETLecturerSupportCode", Value: "" },
                { Name: "HETLecturerSupportTitle", Value: "" }
            ]
            :
            [
                { Name: "HETLecturerSupportCode", Value: "" },
                { Name: "HETLecturerSupportTitle", Value: "" },
            ]

        this.state = {
            model: model,
            selectedHETLecturerSupportProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove HET Lecturer Support', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/HETLecturerSupportsetup/getsearch"}
                    entityViewPath='/HETLecturerSupportsetup'
                    title='HET Lecturer Support'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="HETLecturerSupportTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/HETLecturerSupportSetup/removeHETLecturerSupport"} useDeletePost={true}
                    promptTitle={"Remove HETLecturerSupport Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the HET Lecturer Support programme is a permanent action and the HET Lecturer Support programme will not be available going forward. Are you sure you want to remove this HET Lecturer Support programme?"}
                >
                    <HETLecturerSupportSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(HETLecturerSupportSetupSearch));

